/**
 * @generated SignedSource<<1c3f338f6ef346090a6e49c078cc02f1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceSignalDescription_signalWorkspace$data = {
  readonly body: string | null;
  readonly descriptionFiles: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"LinkedContent_files">;
  }>;
  readonly descriptionImages: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"LinkedContent_images">;
  }>;
  readonly formattedBody: string | null;
  readonly " $fragmentType": "WorkspaceSignalDescription_signalWorkspace";
};
export type WorkspaceSignalDescription_signalWorkspace$key = {
  readonly " $data"?: WorkspaceSignalDescription_signalWorkspace$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceSignalDescription_signalWorkspace">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceSignalDescription_signalWorkspace",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "body",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formattedBody",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "descriptionImages",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "LinkedContent_images"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "descriptionFiles",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "LinkedContent_files"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SignalWorkspace",
  "abstractKey": null
};

(node as any).hash = "ff12c89738a2a2f970ca65a088623fa0";

export default node;
